import type { WidgetOptions } from '@/types'
import { readonly, ref } from 'vue'

const widgetOptions = ref<WidgetOptions>({
    inline: false,
    autoCloseWidget: false,
    customPagePreview: false,
    customPageGridEnabled: true,
    autoHeight: false,
    loading: true,
    cssConfig: {},
})

const setOptions = (options: Partial<WidgetOptions>) => {
    widgetOptions.value = {
        ...widgetOptions.value,
        ...options,
    }
}

function useWidgetOptions() {
    return {
        options: readonly(widgetOptions),
        setOptions,
    }
}

export default useWidgetOptions
